module.exports = __webpack_public_path__ + "static/media/Mushroom.6ac49770.png";